import create from 'zustand'
import { loadAll, saveAll } from '../services/dataService'

const initial = loadAll()

export const useDataStore = create((set, get) => ({
    data: initial,
    save: () => { saveAll(get().data) },
    list: (module) => get().data[module] || [],
    createItem: (module, item) => {
        const arr = [...(get().data[module] || []), item]
        set(state => ({ data: { ...state.data, [module]: arr } }))
        saveAll(get().data)
    },
    updateItem: (module, index, item) => {
        const arr = [...(get().data[module] || [])]
        arr[index] = item
        set(state => ({ data: { ...state.data, [module]: arr } }))
        saveAll(get().data)
    },
    deleteItem: (module, index) => {
        const arr = [...(get().data[module] || [])]
        arr.splice(index, 1)
        set(state => ({ data: { ...state.data, [module]: arr } }))
        saveAll(get().data)
    }
}))
